<template>
    <DataTable default-to-primera :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable">
        <span slot="after-filters">
          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="downloadExcel" flat>
              <v-icon color="primary">far fa-file-excel</v-icon>
            </v-btn>
            <span>Descargar XLS</span>
          </v-tooltip>
        </span>
    </DataTable>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'

export default {
  mixins: [downloadFileMixin, paginationMixin],

  components: {
    DataTable
  },

  data () {
    return {

      headers: [
        { text: 'Club deudor', value: 'club_deudor', sortable: false, align: 'left' },
        { text: 'Club acreedor', value: 'club_acreedor', sortable: false, align: 'left' },
        { text: 'Apellido', value: 'playerLastName', sortable: false, align: 'left' },
        { text: 'Nombre', value: 'playerFirtName', sortable: false, align: 'left' },
        { text: 'Tipo', value: 'tipo', sortable: false, align: 'left', filterField: true },
        { text: 'Estado', value: 'estado', sortable: false, align: 'left', filterField: true },
        { text: 'Estado', value: 'estado', sortable: false, align: 'left', visible: false }
      ],
      properties: ['clubDeudor', 'clubAcreedor', 'playerLastName', 'playerFirstName', 'tipo', 'estado'],
      path: 'transferencias/list',
      filterPath: 'filters/transferencias'
    }
  },

  methods: {
    getExcelPath () {
      return 'transferencias/xls' + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return 'transferencias'
    }
  }
}
</script>

<style scoped>

</style>
